<template>
  <div class="main-graph-window">
    <div>
      <matrix-view-component
        :matrix-view="matrixView"
        :main-sector="mainSector"
        :sub-sector="selectedTab"
      />
    </div>
    <div class="menu-wrapper" @mouseenter="matrixView = false">
      <ul class="sub-menu-dropup">
        <li
          class="dropdown-item btn btn-block btn-light-gray"
          v-for="tab in paginate(graphTabs)[tabPaginate]"
          :key="tab"
          @click="TabClick(tab)"
          @mouseenter="hoveringTab = tab.alias"
          @mouseleave="hoveringTab = false"
          :class="{
            active: selectedTab === tab.alias.toUpperCase(),
            'cal-match':
              selectedCalendarType.alias === mainCalendarSection &&
              selectedTab === tab.alias
          }"
        >
          <i
            class="fas fa-times cancel-filter"
            v-if="checkFilterTab(tab.alias)"
            @click.stop="resetTabFilter(tab.alias)"
          ></i>
          <span
            class="dropdown-item-left"
            :class="{
              longTitleFontSize: tab.name.length > 6
            }"
            >{{ tab.name }}</span
          >
          <span
            class="dropdown-item-right"
            v-if="
              tab.hasOwnProperty('subMenu') || tab.hasOwnProperty('presetTabs')
            "
            ><i class="fas fa-caret-right"></i
          ></span>

          <!--          default sub menus-->
          <!--          <ul
            v-click-outside="closeSubTab"
            class="sub-menu-main"
            v-if="
              tab.hasOwnProperty('subMenu') &&
                ((hoveringTab === tab.alias || selectedTab === tab.alias) &&
                  openSubTab)
            "
          >
            <li
              class="dropdown-item btn btn-block btn-light-gray"
              v-for="subTab in tab.subMenu"
              :key="subTab.id"
              @click.stop="clickSubTab(tab, subTab)"
              :class="{
                active: selectedSubTab === subTab.alias
              }"
            >
              <span class="dropdown-item-left sub">{{ subTab.name }}</span>
            </li>
          </ul>-->

          <!--          presets sub menus-->
          <!--          <ul
            v-click-outside="closeSubTab"
            class="sub-menu-main"
            v-if="tab.hasOwnProperty('presetTabs') && hoveringTab === tab.alias"
          >
            <li
              class="dropdown-item btn btn-block btn-light-gray"
              v-for="subTab in statsTabs"
              :key="subTab.id"
              @click.stop="setPresetFromTab(subTab, tab, true)"
              :class="{
                active: selectedCalendarType.preset === subTab.alias
              }"
            >
              <span class="dropdown-item-left sub">{{ subTab.name }}</span>
            </li>
          </ul>-->
        </li>
      </ul>
      <div class="arrow-down">
        <div class="presets-container dropup">
          <!--          <button
            class="btn btn-info pre-btn dropdown-toggle"
            data-toggle="dropdown"
          >
            PRESETS
          </button>-->
          <div class="dropdown-menu sub-menu-presets-tab">
            <button
              class="btn btn-block preset-tab"
              v-for="subTab in presetsTabs"
              :key="subTab.id"
              @click.stop="setPresetFromTab(subTab, tab)"
              :class="{
                active: selectedCalendarType.preset === subTab.alias
              }"
            >
              {{ subTab.name }}
            </button>
            <button
              class="btn btn-block preset-tab stats-btn"
              @click="setMatrixView(selectedTab)"
              v-if="checkForMatrix(selectedTab)"
            >
              STATS
            </button>
          </div>
          <div class="top-bar">
            <div class="inner-bar">total as: {{ counters.as }}</div>
            <div class="inner-bar">total users: {{ counters.users }}</div>
            <div class="inner-bar" v-if="asDates">
              dates:
              {{ asDates[0] }} -
              {{ asDates[1] }}
              <span class="for-diff-in-days">{{ asDates[2] }}</span>
            </div>
          </div>
        </div>

        <!--        <i
          v-if="graphTabs.length > tabsLength"
          :class="{
            disabled_scroll: paginate(graphTabs)[tabPaginate + 1] === undefined
          }"
          class="fas fa-angle-down"
          @click="tabPaginate++"
        ></i>
        <i
          v-if="graphTabs.length > tabsLength"
          :class="{
            disabled_scroll: paginate(graphTabs)[tabPaginate - 1] === undefined
          }"
          class="fas fa-angle-up"
          @click="tabPaginate&#45;&#45;"
        ></i>-->
      </div>
    </div>
    <div class="chart-section">
      <div class="deposit-chart">
        <canvas class="as-chart" id="main-chart-assignments"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import { mapActions, mapGetters, mapState } from "vuex";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CahartAnnot from "chartjs-plugin-annotation";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import moment from "moment";
import MatrixViewComponent from "../../components/matrix_view/MatrixViewComponent";
import ClickOutside from "vue-click-outside";
import vClickOutside from "v-click-outside";
import apiClientCreator from "@/helpers/api/request";

const StatusBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            beginAtZero: true,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },
    // legend: {
    //     position: "top",
    //     align: "end",
    //     labels: {
    //         boxWidth: 20,
    //         fontSize: 10,
    //         display: false
    //     },
    //     onHover: function(e) {
    //         e.target.style.cursor = 'pointer';
    //     }
    // },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "AsCharts.component",
  components: {
    MatrixViewComponent
  },
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "salesPersonList",
      "multiSelectChartData",
      "selectedCalendarType",
      "clickFromChart",
      "generalQueryObject"
    ]),
    ...mapGetters("clients", ["getMultiSelectChartData"])
  },
  mixins: [UsersPermissionCheck],
  props: {
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    },
    tabs: {
      type: Array,
      required: true
    },
    presetsTabs: {
      type: Array,
      required: true
    },
    statsTabs: {
      type: Array,
      required: true
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      StatusBar: StatusBar,
      AsGroupBar: {
        type: "bar",
        options: {
          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          },
          plugins: {
            datalabels: {
              display: function(ctx) {
                if (ctx.datasetIndex === 0) {
                  return true;
                } else {
                  return false;
                }
              },
              align: "end",
              anchor: "end",
              offset: -5,

              font: {
                family: "Montserrat"
              },
              fontSize: 9,
              color: function(context) {
                return context.dataset.borderColor;
              },
              formatter: function(value) {
                return value === 0 ? "" : value;
              }
            }
          },
          aspectRatio: 2,
          // responsive:true,
          scales: {
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  display: false,
                  padding: 0,
                  fontColor: "#44A2D2", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 10,
                  /*            callback: function(value, index, values) {
                                return value + " %";
                              },*/
                  beginAtZero: true
                  //min: 0,
                  // max: 100
                }
              }
            ],
            xAxes: [
              {
                stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)"
                },
                ticks: {
                  beginAtZero: true,
                  padding: 0,
                  fontColor: "#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 10
                }
              }
            ]
          },
          legend: {
            // onClick: (value, index) => {
            //   let id = index.datasetIndex;
            //
            //   this.updateAsCharts(id, index,"AS");
            // },
            labels: {
              boxWidth: 20,
              fontSize: 10
              // display: false
            }
          },
          tooltips: {
            enabled: true,
            mode: "single",
            callbacks: {
              label: function(value, index, values) {
                let idx = value.index;
                let perc = (value.value / index.datasets[0].data[idx]) * 100;
                let label = index.datasets[value.datasetIndex].label;
                return [
                  label + ":" + value.value,
                  perc.toFixed(1).toString() + "%"
                ];
              }
            }
          }
        }
      },

      graphTabs: [],
      mainCalendarSection: "ASSIGN",
      hoveringTab: false,
      openSubTab: false,
      mainChartTab: null,
      chartData: [],
      allData: {},
      selectedTab: "",

      requestsForTabs: {},
      tabPaginate: 0,
      tabsLength: 8,
      ext_tabs: [
        {
          id: 1,
          name: "USERS",
          alias: "USERS",
          presetTabs: true,
          statisticTab: true,
          ex_tab: true,
          ex: true
        }
      ],
      matrixView: false,
      globalDateRange: "TODAY",
      counters: {
        as: 0,
        users: 0
      },
      asDates: null
    };
  },
  created() {
    this.graphTabs = this.tabs;
    this.selectedTab = this.graphTabs[0].alias.toUpperCase();
  },
  watch: {
    multiSelectChartData: {
      handler() {
        this.initialChartData(this.getMultiSelectChartData);
      },
      deep: true
    }
  },

  mounted() {
    if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
      this.graphTabs = [...this.graphTabs, ...this.ext_tabs];
    }
  },
  methods: {
    diffTimeInDaysForNaChartTitle(d1, d2) {
      let date1 = new Date(d1);
      let date2 = new Date(d2);
      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays + 1 + "Days";
    },
    async initialChartData(data) {
      if (this.mainSector === data.selectedSector) {
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).removeClass("loading");
        if (data.fromChart) {
          return;
        }
        let tab = this.ext_tabs.filter(tab => {
          return tab.alias === this.selectedTab;
        });
        if (tab.length > 0) {
          await this.fetchExternalGraphs(tab[0]);
          return;
        }
        // this.$store.commit("clients/setSelectedCalendarType", {
        //   alias: this.mainCalendarSection,
        //   preset: null
        // });
        this.mainSector = data.selectedSector;
        this.allData = data;
        this.chartData = data.data[this.mainSector].data;
        this.selectedTab = data.data[this.mainSector].selectedTab.toUpperCase();
        let lineChartStatus = `main-chart-assignments`;
        if (this.statusChartTab) {
          this.statusChartTab.destroy();
        }
        if (!this.chartData.hasOwnProperty(this.mainSector)) {
          this.createChart(
            lineChartStatus,
            this.StatusBar,
            this.chartData,
            this.selectedTab
          );
        }
      }
    },
    async TabClick(tab) {
      if (
        (!tab.hasOwnProperty("ex") && !tab.ex) ||
        (tab.hasOwnProperty("ex") &&
          tab.hasOwnProperty("combine") &&
          tab.combine)
      ) {
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        // if (this.selectedTab !== tab.alias) {
        //   this.$store.commit("clients/setSelectedCalendarType", {
        //     alias: this.mainCalendarSection,
        //     preset: null
        //   });
        // }
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).addClass("loading");
        this.selectedTab = tab.alias;
        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;
        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);
      }
      if (tab.hasOwnProperty("ex") && tab.ex) {
        this.selectedTab = tab.alias;
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        await this.fetchExternalGraphs(tab);
      }
    },
    checkForSubMenu(mainTab) {
      let allTabs = [...this.tabs, ...this.ext_tabs];

      return allTabs.find(tab => {
        return tab.alias === mainTab && tab.hasOwnProperty("subMenu");
      });
    },
    clickSubTab(mainTab, subTab) {
      this.openSubTab = true;
      this.selectedSubTab = subTab.alias;
      if (subTab.hasOwnProperty("presetTab") && subTab.presetTab) {
        if (this.selectedSubTab === "MATRIX") {
          this.setPresetFromTab(subTab);
          this.TabClick(mainTab);
        }

        return;
      }
      //functions of sub tabs
    },

    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },
    clickOnMainTab(alias) {
      this.$store.commit("clients/setMainGraphTabData", alias);
    },
    async fetchExternalGraphs(subSector) {
      if (this.statusChartTab) {
        this.statusChartTab.destroy();
      }
      let tab = subSector.alias;
      let element = document.getElementsByClassName(
        "dropdown-item btn btn-block btn-light-gray active"
      );
      $(element).addClass("loading");
      this.depUsersStatsToday = [];
      this.requestsForTabs[tab] = true;

      if (!this.showReset) {
        this.resetMainFilters();
      } else {
        this.mainFilters = this.generalQueryObject;
      }
      //functions for ext tabs
      if (tab === "USERS") {
        await this.fetchUserAssignments();
      }

      this.requestsForTabs[tab] = false;
      $(element).removeClass("loading");
    },

    async fetchUserAssignments() {
      this.AssignmentsUsersData = {};

      let tempQuery = Object.assign({}, this.generalQueryObject);
      if (
        !tempQuery.hasOwnProperty("assigned_at_from") &&
        !tempQuery.hasOwnProperty("assigned_at_to")
      ) {
        tempQuery.assigned_at_from = moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        );

        tempQuery.assigned_at_to = moment(this.defaultPresets().end).format(
          "YYYY-MM-DD"
        );
      }

      let assignmentObj = [
        {
          key: "na",
          sector: "no_answer",
          subSector: "users",
          query: {}
        },
        {
          key: "rf",
          sector: "referral",
          subSector: "users",
          query: {}
        },
        {
          key: "ld",
          sector: "leads",
          subSector: "users",
          query: {
            leads: 1
          }
        },
        {
          key: "ca",
          sector: "call_again",
          subSector: "users",
          query: {
            scheduled_calls: 1
          }
        },
        {
          key: "dp",
          sector: "deposits",
          subSector: "users",
          query: {
            deposit: 1
          }
        },
        {
          key: "tr",
          sector: "transfer",
          subSector: "users",
          query: {
            client_transfers_type: [1, 2]
          }
        }
      ];

      let baseUrl = "client/stats/multiselect/";

      await Promise.all(
        assignmentObj.map(async obj => {
          let addUrl = `${obj.sector}/${obj.subSector}`;
          obj.key === "tr" ? (addUrl = `${obj.sector}/${obj.subSector}/0`) : "";

          let finalUrl = baseUrl + addUrl;
          const loop = await apiClientCreator(finalUrl)
            .get("", { params: { ...tempQuery, ...obj.query } })
            .then(res => {
              this.AssignmentsUsersData[obj.key] = res.data;
            });
        })
      );

      let chartCanvasId = "main-chart-assignments";

      await this.createAsGroupChart(
        chartCanvasId,
        this.AsGroupBar,
        this.AssignmentsUsersData,
        assignmentObj
      );
    },

    createAsGroupChart(chartId, chartOpt, stats, keysObj) {
      let canvasChartId = chartId;
      let opt = chartOpt.options;
      const NewData = stats;
      let ChartCounter = {
        total: []
      };

      let totalLine = [];

      let newSortArray = [];

      let ChartLabels = [];
      let UserIdData = [];

      this.salesPersonList.forEach(person => {
        let userTotal = 0;
        keysObj.map(key => {
          let tempCount = NewData[key.key].find(data => data.id === person.id);
          let count = tempCount ? tempCount.count[0] : 0;
          userTotal += count;
          !ChartCounter.hasOwnProperty(key.key)
            ? (ChartCounter[key.key] = [])
            : "";
          ChartCounter[key.key].push(count);
        });
        ChartCounter["total"].push(userTotal);
        UserIdData.push(person.id);
        ChartLabels.push(this.namesFormatter(person.full_name));
      });

      //
      // newSortArray.sort(function(a, b) {
      //   return b.total - a.total;
      // });

      newSortArray.forEach(data => {
        UserIdData.push(data.userId);
        ChartLabels.push(data.userName);
        ChartCounter["na"].push(data.na);

        ChartCounter["rf"].push(data.rf);

        ChartCounter["ld"].push(data.ld);

        ChartCounter["ca"].push(data.ca);

        ChartCounter["tr"].push(data.tr);

        ChartCounter["dep"].push(data.dep);

        totalLine.push(data.total);
      });

      const data = {
        labels: ChartLabels,
        datasets: [
          {
            type: "line",
            label: "Total",
            fill: false,
            borderColor: "rgba(0,175,255,0.4)", //"rgba(186,231,85,0.9)",
            borderWith: 0.5,
            backgroundColor: "#e755ba",
            pointBackgroundColor: "rgba(0,175,255,0.4)",
            pointBorderColor: "rgba(0,175,255,0.4)",
            pointHoverBackgroundColor: "rgba(0,175,255,0.4)",
            pointHoverBorderColor: "rgba(0,175,255,0.4)",
            fontColor: "rgba(0,175,255,0.5)",
            data: totalLine
          },
          {
            type: "bar",
            label: "NA",
            data: ChartCounter["na"],
            backgroundColor: "rgba(244,81,30,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(244,81,30)",
            maxBarThickness: 20,
            display: false,
            hidden: true
          },
          {
            type: "bar",
            label: "RF",
            data: ChartCounter["rf"],
            backgroundColor: "rgba(175,49,49,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(175,49,49)",
            maxBarThickness: 20,
            display: false,
            hidden: true
          },
          {
            type: "bar",
            label: "LD",
            data: ChartCounter["ld"],
            backgroundColor: "rgba(66, 117, 236,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(66, 117, 236)",
            maxBarThickness: 20,
            display: false,
            hidden: true
          },
          {
            type: "bar",
            label: "SC",
            data: ChartCounter["ca"],
            backgroundColor: "rgb(255,164,0,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(2255,164,0)",
            maxBarThickness: 20,
            display: false,
            hidden: true
          },
          {
            type: "bar",
            label: "DEP",
            data: ChartCounter["dep"],
            backgroundColor: "rgba(173,0,206,0.7)",
            borderWidth: 0.5,
            borderColor: "rgba(173,0,206)",
            maxBarThickness: 1,
            display: false,
            hidden: true
          },
          {
            type: "bar",
            label: "TRNS",
            data: ChartCounter["tr"],
            borderColor: "rgb(171,155,12)",
            backgroundColor: "rgba(250,225,5,0.4)",
            borderWidth: 0.5,
            maxBarThickness: 20,
            display: false,
            hidden: true
          }
        ]
      };

      const dataPerc = {
        labels: ChartLabelsPerc,
        datasets: [
          {
            type: "bar",
            label: "NA",
            data: ChartPercCounter["na"],
            backgroundColor: "rgba(244,81,30,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(244,81,30)",
            maxBarThickness: 20
          },
          {
            type: "bar",
            label: "RF",
            data: ChartPercCounter["rf"],
            backgroundColor: "rgba(175,49,49,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(175,49,49)",
            maxBarThickness: 20
          },
          {
            type: "bar",
            label: "LD",
            data: ChartPercCounter["ld"],
            backgroundColor: "rgba(66, 117, 236,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(66, 117, 236)",
            maxBarThickness: 20
          },
          {
            type: "bar",
            label: "SC",
            data: ChartPercCounter["ca"],
            backgroundColor: "rgb(255,164,0,0.4)",
            borderWidth: 0.5,
            borderColor: "rgba(2255,164,0)",
            maxBarThickness: 20
          },
          {
            type: "bar",
            label: "DEP",
            data: ChartPercCounter["dep"],
            backgroundColor: "rgba(173,0,206,0.7)",
            borderWidth: 0.5,
            borderColor: "rgba(173,0,206)",
            maxBarThickness: 20
          },
          {
            type: "bar",
            label: "TRNS",
            data: ChartPercCounter["tr"],
            borderColor: "rgb(171,155,12)",
            backgroundColor: "rgba(250,225,5,0.4)",
            borderWidth: 0.5,
            maxBarThickness: 20
          }
        ]
      };

      if (opt.annotation) {
        opt.annotation = null;
      }
      if (totalLine.length > 1) {
        opt.annotation = this.returnNewAverageLine(
          totalLine.reduce((a, b) => a + b) / totalLine.length,
          true,
          "rgba(103,206,255,0.8)",
          255
        );
      }
      if (this.AsChartBar) {
        this.AsChartBar.destroy();
      }

      if (this.AsPercChartBar) {
        this.AsPercChartBar.destroy();
      }

      const ctx = document.getElementById(canvasChartId);

      this.AsChartBar = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      const ctxPerc = document.getElementById(canvasPercChartId);

      this.AsPercChartBar = new Chart(ctxPerc, {
        type: chartPercOpt.type,
        data: dataPerc,
        options: optPerc,
        plugins: [ChartDataLabels]
      });

      ctx.onclick = evt => {
        let tempChart = this.AsChartBar;
        let activePoints = tempChart.getElementAtEvent(evt);
        if (activePoints[0]) {
          let dataLabel = activePoints[0]._model.datasetLabel;
          let idx = activePoints[0]["_index"];
          let userId = UserIdData[idx];
          let userValue = tempChart.data.labels[activePoints[0]._index];
          this.asSelectedUser = userValue;
          this.clickAsChart(dataLabel, userId);
        }
      };

      ctxPerc.onclick = evt => {
        let activePoints = this.AsMdPercChartBar.getElementAtEvent(evt);
        if (activePoints[0]) {
          let dataLabel = activePoints[0]._model.datasetLabel;
          let idx = activePoints[0]["_index"];
          let userId = UserIdDataPerc[idx];
          let userValue = this.AsMdPercChartBar.data.labels[
            activePoints[0]._index
          ];
          this.asSelectedUser = userValue;
          this.clickAsMdChart(dataLabel, userId);
        }
      };
    },

    paginate(stats) {
      let pageSize = this.tabsLength;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    resetMainFilters() {
      this.mainFilters = {
        assigned_at_from: moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        ),
        assigned_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
        special_req: true
      };
    },
    createChart(chartId, chartOpt, stats) {
      let opt = chartOpt.options;
      const NewData = stats;
      let labels = [];
      let onlineCounts = [];
      let ids = [];

      NewData.forEach(num1 => {
        if (num1.count[0] === 0) {
          return;
        }
        labels.push(num1.title.substring(0, 17));
        onlineCounts.push(num1.count[0]);
        ids.push(num1.id);
      });

      if (this.generalQueryObject.hasOwnProperty("assigned_at_from")) {
        this.asDates = [
          this.generalQueryObject.assigned_at_from
            .split("-")
            .reverse()
            .join("-"),
          this.generalQueryObject.assigned_at_to
            .split("-")
            .reverse()
            .join("-"),
          this.diffTimeInDaysForNaChartTitle(
            this.generalQueryObject.assigned_at_from,
            this.generalQueryObject.assigned_at_to
          )
        ];
      } else {
        this.asDates = null;
      }
      this.counters.as = onlineCounts.reduce((a, b) => a + b, 0);
      this.counters.users = onlineCounts.length;

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: onlineCounts, //onlineTrans,
            fill: true,
            borderColor: "rgb(171, 206, 64)",
            backgroundColor: "rgb(171, 206, 64,0.7)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.mainChartTab) {
        this.mainChartTab.destroy();
      }

      if (opt.annotation) {
        opt.annotation = null;
      }
      if (onlineCounts.length > 0) {
        opt.annotation = this.returnAverageLine(
          onlineCounts.reduce((a, b) => a + b) / onlineCounts.length,
          true,
          "rgb(66, 117, 236,0.5)",
          340
        );
      }

      const ctx = document.getElementById(chartId);
      this.mainChartTab = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      ctx.onclick = evt => {
        this.clickOnChart(this.mainChartTab, evt, ids);
      };
    },
    returnAverageLine: (avg, enabled, lineColor, pose, YAdjust = -10) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avg,
          borderColor: lineColor,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            // Background color of label, default below
            backgroundColor: "rgba(0,0,0,0)",

            // Font family of text, inherits from global
            fontFamily: "Montserrat",

            // Font size of text, inherits from global
            fontSize: 10,

            // Font style of text, default below
            // fontStyle: "bold",

            // Font color of text, default below
            fontColor: "#000",

            // Padding of label to add left/right, default below
            xPadding: 4,

            // Padding of label to add top/bottom, default below
            yPadding: 4,

            // Radius of label rectangle, default below
            cornerRadius: 5,

            // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
            position: "center",

            // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
            // For horizontal lines positioned left or right, negative values move
            // the label toward the edge, and positive values toward the center.
            xAdjust: pose,

            // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
            // For vertical lines positioned top or bottom, negative values move
            // the label toward the edge, and positive values toward the center.

            yAdjust: YAdjust,

            // Whether the label is enabled and should be displayed
            enabled: enabled,

            // Text to display in label - default is null. Provide an array to display values on a new line
            content: avg.toFixed(0),

            // Rotation of label, in degrees, default is 0
            rotation: 90
          }
        },

        {}
      ]
    }),

    setPresetFromTab(subTab, mainTab, setTab = null) {
      if (subTab.presetTab) {
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: this.mainCalendarSection,
          preset: subTab.alias
        });
      } else {
        this.setMatrixView(mainTab);
      }
      if (setTab) {
        if (this.selectedTab !== mainTab.alias) {
          this.TabClick(mainTab);
        }
      }
    },
    setMatrixView(tab) {
      this.matrixView = true;
    },
    closeMatrix() {
      this.matrixView = false;
    },

    resetTabFilter(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        mainObj.data[this.mainSector][tab] = false;
      } else {
        mainObj.data[this.mainSector] = {
          [tab]: false
        };
      }
      mainObj.lastSector = this.mainSector;
      mainObj.subSector = this.selectedTab;
      this.$store.commit("clients/setClickFromChart", mainObj);
    },
    checkFilterTab(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        if (mainObj.data[this.mainSector].hasOwnProperty(tab)) {
          if (mainObj.data[this.mainSector][tab]) {
            return true;
          }
        }
      }
      return false;
    },
    clickOnChart(chart, evt, ids) {
      let activePoints = chart.getElementAtEvent(evt);
      if (activePoints[0]) {
        let idx = activePoints[0]["_index"];
        let selectedId = ids[idx];
        let mainObj = Object.assign({}, this.clickFromChart);
        if (mainObj.data.hasOwnProperty(this.mainSector)) {
          mainObj.data[this.mainSector][this.selectedTab] = [
            { id: selectedId }
          ];
        } else {
          mainObj.data[this.mainSector] = {
            [this.selectedTab]: [{ id: selectedId }]
          };
        }
        mainObj.lastSector = this.mainSector;
        mainObj.subSector = this.selectedTab;
        this.$store.commit("clients/setClickFromChart", mainObj);
      }
    },
    closeSubTab() {
      this.openSubTab = false;
    },
    defaultPresets(range = this.globalDateRange) {
      if (range === "TODAY") {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          start: today,
          end: today
        };
      }
      if (range === "YESTERDAY") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
        );
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .toDate();
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const n = new Date();
        const startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
        );
        const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }

      if (range === "LAST_30_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_90_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_180_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "TOMORROW") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
        );
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "NEXT_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
        );
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  padding-top: 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  /* overflow-x: visible;*/
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 12px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
}

.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*  padding: 1px 0px;
  margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  border-radius: 0px 5px 5px 0px;
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

.dropdown-item-left {
  margin-left: 10px;

  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  width: 17px;
}
.chart-section {
  flex: 2;
  width: 92%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 11px;
}
li.active {
  background-color: #abce40;
  color: #fff;
}
.sized_chart {
  max-width: 74%;
  position: relative;
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 75px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}
.sub-menu-main li {
  background-color: #efefef;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 5px;
}
.sub-menu-main li:hover {
  background-color: #dedede;
}
.sub-menu-main li.active {
  background-color: #abce40;
  color: #fff;
}

.dropdown-item-left.sub {
  margin-left: unset;
  width: 50px;
  text-align: center;
}
li.loading {
  background: linear-gradient(-45deg, #abce40, #698028, #abce40, #698028);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }
  //50% {
  //  background-position: 100% 50%;
  //}
  100% {
    background-position: 100% 50%;
  }
}
.arrow-down {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #abce40;
  font-size: 29px;
  cursor: pointer;
}
.disabled_scroll {
  display: none;
}
.cancel-filter {
  margin-top: 2px;
  margin-left: 5px;
}

.presets-container {
  height: 20px;
  margin: 0px;
  padding: 0px;
  display: flex;
}
.pre-btn:focus {
  outline: none;
}
.pre-btn {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-menu-presets-tab {
  max-width: 57px !important;
  min-width: 57px !important;
  padding-left: 2px;
}
.preset-tab {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  max-width: 52px;
}
.preset-tab.active {
  background: #a8a5a5;
  color: #fff;
}
.preset-tab:focus {
  outline: none;
}
.preset-tab:hover {
  background: #d7d7d7;
}
.top-bar {
  display: flex;
  justify-content: space-evenly;
  background-color: #efefef;
  width: 100%;
  height: 15px;
  font-size: 10px;
  position: absolute;
  top: 23px;
  left: 73px;
}
.inner-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}
span.for-diff-in-days {
  padding-left: 8px;
}
.as-chart {
  height: 160px !important;
  padding-top: 10px !important;
}
</style>
